(()=> {
  const WORKER_URL = "https://vizium-chat.andidisanstore.workers.dev/"; // <-- tu URL

  // FAB
  const fab = document.createElement("div");
  fab.id = "vz-chat-fab"; fab.title = "Habla con Vizium"; fab.innerHTML = "💬";

  // Panel
  const panel = document.createElement("div");
  panel.id = "vz-chat-panel";
  panel.innerHTML = `
    <div id="vz-chat-header">
      <div>Asesor Vizium <span class="vz-badge">GPT-5</span>
        <div class="vz-sub">Celulares & Accesorios • Chile</div>
      </div>
      <button id="vz-chat-close" style="background:transparent;border:none;color:#fff;font-size:18px;cursor:pointer">✕</button>
    </div>
    <div id="vz-chat-messages"></div>
    <div id="vz-chat-inputbar">
      <input id="vz-chat-input" type="text" placeholder="Ej: ¿Tienen A36 en Mint?" />
      <button id="vz-chat-send">Enviar</button>
    </div>`;

  // Inyecta en DOM
  document.addEventListener("DOMContentLoaded", ()=>{
    document.body.appendChild(fab);
    document.body.appendChild(panel);
    const css = document.createElement("link");
    const script = document.querySelector('script[src*="vizium-chat.js"]');
    css.rel = "stylesheet";
    css.href = script ? script.src.split('?')[0].replace(/vizium-chat\.js$/, 'vizium-chat.css') : '/assets/vizium-chat.css';
    document.head.appendChild(css);
  });

  // Elementos
  const el = (s)=>document.querySelector(s);
  const historyKey="vz_chat_history";
  let history = JSON.parse(localStorage.getItem(historyKey)||"[]");
  const save=()=>localStorage.setItem(historyKey,JSON.stringify(history));
  const pushUser=t=>{history.push({role:"user",content:t});save();};
  const pushBot=t=>{history.push({role:"assistant",content:t});save();};

  function render(){
    const box = el("#vz-chat-messages"); if(!box) return;
    box.innerHTML="";
    history.forEach(m=>{
      const d=document.createElement("div");
      d.className="vz-msg "+(m.role==="user"?"vz-user":"vz-bot");
      d.textContent=m.content; box.appendChild(d);
    });
    box.scrollTop=box.scrollHeight;
  }
  function welcomeIfEmpty(){
    if(history.length===0){
      pushBot("¡Hola! Soy tu asesor de Vizium 🤖. ¿Buscas Samsung, Motorola o iPhone? También tengo cargadores 25W/45W, power banks 20.000 mAh y protección.");
      render();
    }
  }
  async function send(){
    const inp=el("#vz-chat-input"); const btn=el("#vz-chat-send");
    const text=(inp.value||"").trim(); if(!text) return;
    pushUser(text); render(); inp.value=""; btn.disabled=true;
    try{
      const res=await fetch(WORKER_URL,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({messages:history.map(m=>({role:m.role,content:m.content}))})
      });
      const data=await res.json();
      const reply=data?.choices?.[0]?.message?.content?.trim()||"Perdón, no entendí. ¿Puedes reformular?";
      pushBot(reply); render();
    }catch(e){
      pushBot("Hubo un problema de conexión. Intenta de nuevo en unos segundos 🙏"); render();
    }finally{ btn.disabled=false; }
  }

  // Eventos
  document.addEventListener("click",(e)=>{
    if(e.target?.id==="vz-chat-fab"){
      const p=el("#vz-chat-panel");
      p.style.display = (p.style.display==="flex")?"none":"flex";
      if(p.style.display==="flex") welcomeIfEmpty();
    }
    if(e.target?.id==="vz-chat-close"){ el("#vz-chat-panel").style.display="none"; }
    if(e.target?.id==="vz-chat-send"){ send(); }
  });
  document.addEventListener("keydown",(e)=>{ if(e.key==="Enter" && document.activeElement?.id==="vz-chat-input") send(); });

})();
